/**
 * 積卸地設定ページ用のスクリプト
 */
if (is_route('loading_point.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        loading_point_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.loading_point_event_set = function() {

    let csvSettingModalId = '#loading_point-csv-setting-modal';
    let csvFormId = csvSettingModalId + '-form';

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], false, function(){
            loading_point_setting_event_set();
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        // 保存時はマーカー実座標を正とする（getPointerPosition は保存ボタン位置になり東にずれる）
        let lat = null;
        let lon = null;
        if (_zdcMap._lastMarkerLatLon) {
            lat = _zdcMap._lastMarkerLatLon.lat;
            lon = _zdcMap._lastMarkerLatLon.lon;
        } else if (_zdcMap._zMakers && _zdcMap._zMakers.length > 0 && typeof _zdcMap._zMakers[0].getLatLon === 'function') {
            let latlon = _zdcMap._zMakers[0].getLatLon();
            lat = latlon.lat;
            lon = latlon.lon;
        } else {
            let point = $('#loading_point-setting-modal-point-value').val()
                || $('#loading_point-setting-modal-form input[name="point"]').val()
                || '';
            let match = point.match(/POINT\s*\(\s*([+\-\d.]+)\s+([+\-\d.]+)\s*\)/i);
            if (match) {
                lat = match[1];
                lon = match[2];
            }
        }

        let $form = $('#loading_point-setting-modal-form');
        if (lat != null && lon != null) {
            let wkt = 'POINT(' + lat + ' ' + lon + ')';
            $form.find('input[name="point"]').val(wkt);
            $form.find('input[name="latitude"]').val(lat);
            $form.find('input[name="longitude"]').val(lon);
            if (_zdcMap._geom && _zdcMap._geom.length > 0) {
                _zdcMap._geom.val(wkt);
            }
        } else {
            $form.find('input[name="latitude"]').val('');
            $form.find('input[name="longitude"]').val('');
        }

        _modal.submit(this, 'save-modal');
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + 'csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', csvSettingModalId + '-csv', function () {
        let csvFormId = csvSettingModalId + '-form';
        let action = $(csvFormId).data('confirm-action');
        let datas = new FormData($(csvFormId).get(0));
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $("[data-csv-save-modal]").prop('disabled', true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(csvSettingModalId + '-csv-submit-message').removeClass('display-none');
            $(csvSettingModalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
            $(this).val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(csvSettingModalId + '-csv-error').removeClass('display-none');
                $(csvSettingModalId + '-csv-error').append($('<li></li>').text(message));
            });
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let action = $(csvFormId).attr('action');
        let datas = new FormData($(csvFormId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(csvSettingModalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });
}

/**
 * 設定モーダルイベントセット
 */
window.loading_point_setting_event_set = function()
{
    /*---- 行先区分・積卸地区分init ----*/
    set_by_destination_type($('.loading-point-setting-destination-type:checked').val() || '');

    /*---- 地図初期化 ----*/
    let map = $('#loading_point-setting-modal').find('.zdc-map');
    // modal内の要素の幅、高さを性格に取得するため、モーダル生成後1秒おいて処理する
    window.setTimeout(function () {
        let options = {
            addressOfMarker: true,
        };
        if (map.length > 0) {
            map.attr('width', map.width() + 'px');
            map.attr('height', map.height() + 'px');
            if (map.data('zip_lat') !== '' || map.data('zip_lon') !== '') {
                options.lat = map.data('zip_lat');
                options.lon = map.data('zip_lon');
            }
            _zdcMap.Map.init(map, options, true);
        }
    }, 1000);

    /*---- 要素リサイズ時地図エリア・地図リサイズ ----*/
    $(window).resize(function () {
        if (map.length > 0) {
            map.attr('width', map.width() + 'px');
            map.attr('height', map.height() + 'px');
            _zdcMap.Map.refresh();
        }
    });

    /*---- 郵便番号変更 ----*/
    // 住所から緯度経度を取得し、地図中心を移動する
    $(document).on('click', '.zipcode-button', function ()
    {
        if (map.length > 0) {
            //_zdcMap.Map.setFromZipcode($(this).prev('input[name="zipcode"]').val());
            _zdcMap.Map.setFromZipcodeAndMarkerSet($(this).prev('input[name="zipcode"]').val());
        }
    });

    /*---- 都道府県変更 ----*/
    // 住所から緯度経度を取得し、地図中心を移動する
    $(document).on('change', 'select[name="prefecture"]', function (e)
    {
        // バブリング停止
        e.preventDefault();
        e.stopPropagation();

        if (map.length > 0) {
            _zdcMap.Map.setFromAddress(
                $(this).val(),
                $('input[name="municipality"]').val(),
                $('input[name="address"]').val()
            );
        }
    });

    /*---- 市区町村変更 ----*/
    // 住所から緯度経度を取得し、地図中心を移動する
    $(document).on('change', 'input[name="municipality"]', function (e)
    {
        // バブリング停止
        e.preventDefault();
        e.stopPropagation();

        if (map.length > 0) {
            _zdcMap.Map.setFromAddress(
                $('select[name="prefecture"]').val(),
                $(this).val(),
                $('input[name="address"]').val(),
            );
        }
    });

    /*---- 住所変更 ----*/
    // 住所から緯度経度を取得し、地図中心を移動する
    $(document).on('change', 'input[name="address"]', function (e)
    {
        // バブリング停止
        e.preventDefault();
        e.stopPropagation();

        if (map.length > 0) {
            _zdcMap.Map.setFromAddress(
                $('select[name="prefecture"]').val(),
                $('input[name="municipality"]').val(),
                $(this).val()
            );
        }
    });

    // 行先区分クリック時
    $(document).on('click', 'input[name="destination_type"]', function () {
        if ($(this).prop('checked')) {
            set_by_destination_type($(this).val());
        } else {
            set_by_destination_type('');
        }
    });

    /**
     * 行先区分別選択肢 表示/非表示制御
     * @param type
     */
    function set_by_destination_type(type)
    {
        let all = $('div[class*="destination-type-"]');
        let forType = $('.destination-type-' + type);
        let old = forType.data('old');

        // init
        all.find('.badge-required').addClass('d-none');
        all.find('input').prop('checked', false).prop('disabled', true)
            .parent('label').addClass('disabled').removeClass('active');
        // 紐づく下位タイプ表示
        if (forType.length > 0) {
            forType.find('.badge-required').removeClass('d-none');
            forType.find('input').prop('disabled', false).parent('label').removeClass('disabled');
            forType.find('input[value="' + old + '"]').prop('checked', true).parent('label').addClass('active');
        }
    }

}
